import script from "./DQa.vue?vue&type=script&lang=ts&setup=true"
export * from "./DQa.vue?vue&type=script&lang=ts&setup=true"

import "./DQa.vue?vue&type=style&index=0&id=fae48cc0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fae48cc0"]])

export default __exports__